// API response types - extracted to break circular dependency between index.ts and apiHelpers.ts

export type APIBaseResponse<TData = unknown> = {
    error: string | null;
    success: boolean;
    data: TData;
};

export type APIBasePaginatedResponse<TData = unknown> = {
    error: string | null;
    success: boolean;
    skipped: number;
    taken: number;
    count: number;
    data: TData;
}

export class APIError extends Error {
    constructor(public statusCode: number, public svcError: string = '') {
        super(`Internal API error: ${statusCode}` + (svcError ? `. ${svcError.trim()}` : ''));
    }
}

export type APIMethod<Params, Response> = (params: Params) => Promise<Response>;
